import { Phone, ArrowRight } from "lucide-react";
import { CONTACT } from "./data";
import { ContactForm } from "./ContactForm";

const focusForm = (e) => {
  e.preventDefault();
  const el = document.getElementById("kontaktformular");
  el?.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start" });
  setTimeout(() => document.getElementById("f-namn")?.focus({ preventScroll: true }), 400);
};

export const Contact = () => (
  <section id="kontakt" aria-labelledby="kontakt-title" className="bg-sand py-20 md:py-28 lg:py-36" data-testid="kontakt-section">
    <div className="container-site grid gap-12 lg:grid-cols-12 lg:gap-12 xl:gap-16">
      <div className="reveal lg:col-span-4 xl:col-span-4">
        <p className="eyebrow">Kontakt</p>
        <h2 id="kontakt-title" className="h2 mt-5">Berätta kort om ditt byggprojekt</h2>
        <p className="lede mt-5">Beskriv vad du behöver hjälp med så återkommer Lars.</p>
        <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:flex-wrap lg:flex-col lg:items-start">
          <a href={CONTACT.phoneHref} className="btn-ghost whitespace-nowrap" data-testid="contact-call-button">
            <Phone size={17} strokeWidth={1.75} aria-hidden="true" /> Ring Lars – {CONTACT.phone}
          </a>
          <a href="#kontaktformular" onClick={focusForm} className="btn-primary whitespace-nowrap" data-testid="contact-form-jump-button">
            Beskriv ditt projekt <ArrowRight size={18} strokeWidth={1.75} className="arrow" aria-hidden="true" />
          </a>
        </div>
        <address className="mt-12 border-t border-line pt-8 not-italic" data-testid="contact-details">
          <p className="font-display text-2xl text-ink">{CONTACT.name}</p>
          <p className="mt-1 text-sm text-ink3">Folkare Bygg</p>
          <dl className="mt-6 space-y-3 text-base">
            <div className="flex gap-4">
              <dt className="w-20 shrink-0 text-ink3">Telefon</dt>
              <dd><a href={CONTACT.phoneHref} className="link-underline font-medium text-ink" data-testid="contact-phone-link">{CONTACT.phone}</a></dd>
            </div>
            <div className="flex gap-4">
              <dt className="w-20 shrink-0 text-ink3">E-post</dt>
              <dd><a href={CONTACT.emailHref} className="link-underline break-all font-medium text-ink" data-testid="contact-email-link">{CONTACT.email}</a></dd>
            </div>
            <div className="flex gap-4">
              <dt className="w-20 shrink-0 text-ink3">Org.nr</dt>
              <dd className="font-medium text-ink">{CONTACT.orgNumber}</dd>
            </div>
          </dl>
        </address>
      </div>
      <div className="lg:col-span-8 lg:col-start-5 xl:col-span-8 xl:col-start-5">
        <ContactForm />
      </div>
    </div>
  </section>
);
